import { ConsumerEntity } from '../consumer/consumer.entity';
import { Relation } from '../core/decorators/relation.decorator';
import { BaseEntity } from '../core/entities/base.entity';
import { ConsumerData } from '../core/types';
import { RelationRef } from '../core/types/entity-types';
import { ExplanationEntity } from '../explanation/explanation-entity';
import { ExamEntity } from '../lesson/exam/exam.entity';
import { ExerciseEntity } from '../lesson/exercise/exercise.entity';
import { SubjectEntity } from '../subject/subject.entity';
import { SequenceList } from './interface/sequence-interface';

export class SequenceEntity extends BaseEntity {
  active?: boolean;
  approval!: string;
  changedBy?: string;
  consumerData?: ConsumerData;
  consumerId?: string;
  copyRestricted?: boolean;
  kind?: string;
  name?: string;
  sequence?: SequenceList;
  sortName?: string;
  subjectId?: number;
  version?: number;

  @Relation()
  consumers?: RelationRef<ConsumerEntity>[];

  @Relation()
  subjects?: RelationRef<SubjectEntity>[];

  @Relation()
  exams?: RelationRef<ExamEntity>[];

  @Relation()
  exercises?: RelationRef<ExerciseEntity>[];

  @Relation()
  explanations?: RelationRef<ExplanationEntity>[];
}
